import script from "./MapWithControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapWithControls.vue?vue&type=script&setup=true&lang=ts"

import "./MapWithControls.vue?vue&type=style&index=0&id=21fa310b&lang=less"

const __exports__ = script;

export default __exports__